export default {
    SET_CATEGORY(state, payload) {
    state.category = payload;
  },
  SELECTED_CATEGORY(state, payload) {
    state.selectedCategory = payload;
  },
  SET_SUBCATEGORY(state, payload) {
    state.subcategory = payload;
  },
};